import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import api from "@/lib/api";

export default function MessagesManager() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/messages").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="cms-messages">
      <h2 className="font-serif text-2xl mb-6">Messaggi</h2>
      {items.length === 0 ? <p className="text-[#9C8F94] py-10 text-center">Nessun messaggio.</p> : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.id} className="bg-[#FBF5F1] border border-[rgba(61,50,56,0.08)] rounded-xl p-4">
              <div className="flex items-center justify-between gap-4 mb-2">
                <div className="text-[#3D3238]">{m.name}</div>
                <a href={`mailto:${m.email}`} className="text-xs text-[#C6899E] inline-flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> {m.email}</a>
              </div>
              <p className="text-sm text-[#8C7E83] whitespace-pre-wrap">{m.message}</p>
              <div className="text-[0.65rem] text-[#9C8F94] mt-2">{new Date(m.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
